// src/components/ProductPage/ProductHeader.js
import React from 'react';
import { Box, Tooltip, IconButton } from '@mui/material';
import { Share, Favorite, FavoriteBorder } from '@mui/icons-material';
import { FaFacebookMessenger } from 'react-icons/fa';

const ProductHeader = ({ 
  handleMessengerClick, 
  handleShare, 
  handleToggleFavorite, 
  favoriteLoading, 
  isFavorite,
  productId
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between',
      flexDirection: 'row-reverse',
      mb: 4 
    }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Tooltip title="راسلنا عبر Messenger">
          <IconButton
            onClick={handleMessengerClick}
            sx={{
              bgcolor: '#f5f5f5',
              '&:hover': { bgcolor: '#e0e0e0' },
              color: '#0f3662',
              fontSize: '1.5rem',
              ml: 1
            }}
          >
            <FaFacebookMessenger />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="مشاركة المنتج">
          <IconButton
            aria-label="مشاركة المنتج"
            onClick={handleShare}
            sx={{
              bgcolor: '#f5f5f5',
              '&:hover': { bgcolor: '#e0e0e0' },
              color: '#0f3662',
              fontSize: '1.5rem',
              ml: 1
            }}
          >
            <Share />
          </IconButton>
        </Tooltip>
        
        <Tooltip title={isFavorite(productId) ? 'حذف من المفضلة' : 'إضافة للمفضلة'}>
          <IconButton
            onClick={handleToggleFavorite}
            disabled={favoriteLoading}
            aria-label="إضافة إلى المفضلة"
            sx={{
              bgcolor: '#f5f5f5',
              '&:hover': { bgcolor: '#e0e0e0' },
              color: '#a72c2a',
              fontSize: '1.5rem',
              ml: 1,
              transition: 'all 0.2s ease-in-out',
              '&:disabled': { opacity: 0.6 }
            }}
          >
            {isFavorite(productId) ? (
              <Favorite sx={{ fontSize: 24 }} />
            ) : (
              <FavoriteBorder sx={{ fontSize: 24 }} />
            )}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default ProductHeader;
